(function(angular) {
    'use strict';

    angular.module('aprima-core-ui').factory('apConfirmService', [
        'apConfirm',
        apConfirmService
    ]);

    function apConfirmService(
        apConfirm
    ) {

        return {
            confirm: confirm,
        };

        function confirm(message, okText, cancelText, size) {
            return apConfirm(message, okText, cancelText, size);
        }
    }
})(window.angular);
